import { bankTypes } from '../types/bankActionTypes'
import bankService from 'src/services/bank'
import { action } from 'typesafe-actions'

export const getAllBanksAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await bankService.getAllBanks()
      dispatch(action(bankTypes.GET_ALL_BANKS_SUCCESS, response.data.data))
    } catch (error: any) {
      console.log(error.message)
    }
  }
}

export const getMyBanksDataAction = () => {
  return async (dispatch: any) => {
    try {
      const response: any = await bankService.getMyBanks()
      // console.log(response.data.data)
      dispatch(action(bankTypes.GET_MY_BANKS_SUCCESS, response.data.data))
    } catch (error: any) {
      console.log(error.message)
    }
  }
}

export const deleteBankAccountAction = ({ id, onSuccess, onError }: any) => {
  return async (dispatch: any) => {
    try {
      const payload = await bankService.deleteBankAccount({ id })
      const response = payload.data.data
      console.log(response)
      if (response.successful) {
        dispatch(action(bankTypes.GET_MY_BANKS_SUCCESS))
        onSuccess?.(response.server_response)
      } else {
        onError(response.server_response)
      }
    } catch (error) {
      onError?.getErrorHelper(error)
    }
  }
}

export const bankSettingsAction = ({ payload, onSuccess, onError }: any) => {
  const { bankSettings } = payload

  return async (dispatch: any) => {
    try {
      const response: any = await bankService.createBankAccount(bankSettings)
      console.log(response.data.data)
      if (response.data.data.successful) {
        dispatch(
          action(bankTypes.VERIFY_BANK_ACCOUNT_SUCCESS, response.data.data)
        )
        onSuccess?.(response.data.data.server_response)
      } else {
        onError?.(response.data.data.server_response)
      }
    } catch (error: any) {
      onError?.getErrorHelper(error)
    }
  }
}

export const verifyBankAccountAction = ({
  verifyPayload,
  onVerifySuccess,
  onVerifyError,
}: any) => {
  const { verifyState } = verifyPayload
  return async (dispatch: any) => {
    try {
      const response: any = await bankService.resolveBankAccount(verifyState)
      console.log(response.data.data)
      if (response.data.data.successful) {
        dispatch(action(bankTypes.BANK_SETTINGS_SUCCESS, response.data.data))
        onVerifySuccess?.(response.data.data.server_response)
      } else {
        onVerifyError?.(response.data.data.server_response)
      }
    } catch (error: any) {
      onVerifyError?.getErrorHelper(error)
    }
  }
}
